export default __webpack_public_path__ + "static/bg-gnb-7e5ceaae61db13fdb1449dd878776693.png";